export default "__VITE_ASSET__DBc36KR0__"